import {FC} from "react";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";
import {useSidebarItems} from "../../hooks";
import {PageHeading, PageTemplate} from "../../layout";
import {EntitySourceType} from "../../entities";
import {OldCommonOrgEntitySearch} from "../OldCommonOrgEntitySearch";
import {SearchPageState} from "../SearchPageState";

export const OldClientSearchPage: FC = () => {
  const location = useLocation<SearchPageState>();
  const query = location.search.match(/query=/i)
    ? new URLSearchParams(location.search).get("query") || ""
    : location.state?.query || "";
  const {t} = useTranslation();
  const sidebarItems = useSidebarItems("client-search");

  return (
    <PageTemplate
      id={"client-search-page"}
      title={"Client Search Page"}
      banner={
        <PageHeading
          title={t("client-search.title")}
          summary={t("client-search.summary")}
        />
      }
      sidebarItems={sidebarItems}>
      <OldCommonOrgEntitySearch
        query={query}
        entitySourceType={EntitySourceType.CLIENT}
      />
    </PageTemplate>
  );
};
